/*
 * Extension-wide JS constants. (The existing config.json is empty {}; we keep
 * hard URLs here in code for now — can be promoted to env/runtime config later
 * if we ever need to point at a different Zoltar instance.)
 */

export const ZOLTAR_BASE_URL = 'https://zoltar-demo-pilot.adobe.io';

// The scraper SSE endpoint. Note the literal ':sse' in the path — it's not a
// URL parameter, it's the route name.
export const ZOLTAR_SCRAPE_SSE_PATH = '/scrape/:sse';
